import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Entity, EntityKey} from '../entity/entity';
import {SfrEntity} from '../sfr/sfr-entity';
import {GoogleService} from './google-service';
import {SfrEntry} from '../model/sfr-entry';

@Service()
export class SfrManagementService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getSfrEntity(entityId: string, entityRevision: number): Observable<SfrEntity> {
    let url = this.urlBase + 'sfrManagement/' + entityId + '/' + entityRevision;
    return this.http.get<SfrEntity>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  public save(entity: SfrEntity): Observable<string> {
    let url = this.urlBase + 'sfrManagement/save';
    let body = JSON.stringify(entity);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  public createRequest(key: EntityKey): Observable<Entity> {
    let url = this.urlBase + 'sfrManagement/createRequest';
    return this.getEntityResponse(url, key);
  }

  private getEntityResponse(url: string, key: EntityKey): Observable<Entity> {
    let body = JSON.stringify(key);
    return this.http.post<Entity>(url, body, {headers: this.getPostHeaders()});
  }

  public cancelRequest(key: EntityKey): Observable<Entity> {
    let url = this.urlBase + 'sfrManagement/cancelRequest';
    return this.getEntityResponse(url, key);
  }

  getSfrEntries(entityId: string, entityRevision: number, lineId: string): Observable<SfrEntry[]> {
    const url = this.urlBase + 'sfrManagement/sfrEntries/' + entityId + '/' + entityRevision + '/' + lineId;
    return this.http.get<SfrEntry[]>(url, {headers: this.getRequestHeaders()});
  }

}
